import gromoLogo from "../assets/images/gromo-logo.svg";
import gromoIcon from "../assets/images/gromo-icon.svg";
import gromoBg from "../assets/images/gromo-bg.png";

export const GROMO_LOGO = gromoLogo;
export const GROMO_ICON = gromoIcon;
export const GROMO_BG = gromoBg;
